<template>
<div>
<ContentHeader  v-if="$store.state.sections.section"  :title="$store.state.sections.section.name"  :show_button="true"  icon="arrow-left" buttontype="danger" label="Listeye Geri Dön" url="QuestionlistQuestions" :urlparams="headerurlparams"></ContentHeader>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>


<template v-if="!loading">
<div class="mt-4">

<div class="grid">

<div class="col-12 md:col-12" v-for="item in items">
<h2>{{item.language.name}}</h2>
<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.translation" valkey="translation" @dataChanged="dataChanged($event,item.id)" />
<ClickEditInputRichTextArea  :title="$store.state.languages.lang_phrases.yardim_metni" :value="item.description" valkey="description" @dataChanged="dataChanged($event,item.id)" />


<ClickEditUploadDeletable 
:title="$store.state.languages.lang_phrases.marka_deklerasyon_dosyasi" 
:value="item.filename" 
:filepath="item.filepath" 
valkey="filename" 
@dataChanged="fileChanged($event,item.id)" 
:deletable="true"
@dataDeleted="fileDeleted(item.id)"/>
<ProgressBar v-if="$store.state.ui.upload_progress>0 " :value="$store.state.ui.upload_progress" class="mt-2 mb-2"/>

</div>


</div>
</div>
</template>

</div>
</template>

<script>
export default {

  name: 'BrandTranslations',

  data () {
    return {
      items:[],
      loading:true,
    }
  },
  computed:{
    headerurlparams()
    {
      return {id:this.$store.state.questions.question.questionlist_id}
    }
  },
  mounted()
  {
    this.getData()
  },
  methods:{
    async getData()
    {
        this.items = await this.generalApiGetWithoutLoader("brand/translations/"+this.$route.params.id)
        console.log(this.items)

        this.loading = await false
    },  
     dataChanged(data,id)
    {
      console.log(id);
      console.log(data)
      let formdata = new FormData()
      formdata.append(data.key,data.value)      
      this.generalSubmission(formdata,"brand/translations/"+id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response);      
      this.items = response.data      
    },

    fileChanged(data,id)
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append('decleration_file', data.value[0]); 
      this.generalSubmissionWithProgress(formdata,"brand/translation_file/"+id,this.afterdataChanged)
    },
    fileDeleted(id)
    {
      let formdata = new FormData()
      formdata.append('decleration_file', null); 
      this.generalSubmissionWithProgress(formdata,"brand/translation_file/"+id,this.afterdataChanged)
    },
  }
};
</script>

<style lang="css" scoped>
</style>